module.exports = __webpack_public_path__ + "static/media/header_logo.faf4a656.png";